import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=68c4c38b&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=68c4c38b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4c38b",
  null
  
)

export default component.exports